import {ChangeEvent, FC} from 'react';

import {FieldProps} from 'formik';

import {MenuItem, SxProps, TextField, Theme, useTheme} from '@mui/material';

import {greenColors} from '../../layouts/theme/designSystem';
import {getFieldStyle} from '../../layouts/theme/FieldStyles';

export interface EmpionSelectFieldOption {
  id: string;
  label: string;
}

export interface complexFieldDependency {
  field: string;
  value: any;
}

interface EmpionSelectFieldProps {
  required: boolean;
  options: EmpionSelectFieldOption[];
  label?: string;
  size: 'small' | 'medium';
  dependencies?: string[] | complexFieldDependency[];
  formik: any;
  disabled?: boolean;
  sx?: SxProps<Theme>;
  isQuestionnairePage?: boolean;
  value?: any;
  onChange?: (data: any) => void;
  helperText?: string;
}

export const EmpionSelectField: FC<EmpionSelectFieldProps & FieldProps> = ({
  field,
  required,
  label,
  options,
  size,
  dependencies,
  formik,
  disabled,
  sx,
  isQuestionnairePage,
  value,
  onChange,
  helperText,
}) => {
  const theme = useTheme();
  if (value) {
    field.value = value;
  }
  return (
    <TextField
      select
      fullWidth
      {...field}
      sx={{...getFieldStyle(theme), ...sx}}
      size={size}
      label={label ? (required ? `${label}*` : `${label}`) : ''}
      disabled={disabled}
      helperText={helperText}
      SelectProps={{
        MenuProps: {
          PaperProps: {
            style: {
              backgroundColor:
                isQuestionnairePage ?? '' ? (theme.palette.mode === 'dark' ? greenColors[100] : 'white') : '',
              backgroundImage: 'none',
            },
          },
        },
      }}
      onChange={(e: ChangeEvent<any>) => {
        field.onChange(e);
        onChange && onChange(e.target.value);
        if (dependencies) {
          dependencies.forEach((dependency) => {
            if (typeof dependency === 'string') {
              formik.setFieldValue(dependency, '');
            }

            if (typeof dependency === 'object') {
              formik.setFieldValue(dependency.field, dependency.value);
            }
          });
        }
      }}
    >
      {options.map((option: EmpionSelectFieldOption) => (
        <MenuItem key={option.id} value={option.id} sx={{whiteSpace: {xs: 'normal', sm: 'nowrap'}}}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
};
